import React, { useState } from "react";
import { Container } from "react-bootstrap";
import img1 from "../../assets/Images/Blogs/DeWatermark.ai_1739363347108.png";
import img2 from "../../assets/Images/Blogs/view-beautifully-decorated-green-kitchen.jpg";
import img3 from "../../assets/Images/Blogs/hotel-bathroom.jpg";
import img4 from "../../assets/Images/Blogs/Flux_Dev_a_warm_and_inviting_living_room_scene_with_a_harmonio_1.jpeg";
import img5 from "../../assets/Images/Blogs/Gemini_Generated_Image_fn4jarfn4jarfn4j.jpg";
import img6 from "../../assets/Images/Blogs/Gemini_Generated_Image_3yaoq93yaoq93yao.jpg";
import { useIsMobile } from "../../utils/responsive";
export default function Section3() {
  const [hoveredImage, setHoveredImage] = useState(null);
  const isMobile = useIsMobile();

  const handleImageHover = (index) => {
    setHoveredImage(index);
  };

  return (
    <Container fluid className="p-0">
      {/* Header Row */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "60%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: "1px solid black",
            // borderLeft: "1px solid black",
          }}
        >
          <div
            style={{
              padding: "20px 40px",
            }}
          >
            <h3 className="heading-sm m-0">USE OF THE COLOR WHEEL</h3>
          </div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "30%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}

        {/* Text Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: "1px solid black",
            // borderLeft: "1px solid black",
          }}
          // className="p-5"
        >
          <div
            style={{
              padding: "20px 40px",
            }}
          >
            <p className="body-lg m-0">
              Conceived in 1666 by Sir Isaac Newton to map out the various
              relationships between colours in the spectrum, the wheel is
              essentially a visual representation of 12 core colors in a circle,
              from primary hues to secondary colors and so on. It provides a
              clear and instant visual for exactly which hues contrast and
              coordinate, to help you to devise harmonious, tonal or contrasting
              looks. In essence, color theory is the application of art and
              science on design. It uses the color wheel to explain how colors
              mix, match and contrast, as well as how color can affect mood,
              generate emotions, soothe or aggravate.
            </p>
            <br />
            <p className="body-lg m-0">
              'Color undoubtedly has the power to make our homes look more
              beautiful,' says Dulux Creative Director, Marianne Shillingford.
              'But it also has the power to change the way we feel about them
              and behave in them. It can connect spaces together as much as the
              people in them and it can make us rest better, work better and
              just feel better'.
            </p>
            <br />
            <p className="body-lg m-0">
              While applying the theory of what color schemes combine well is
              pretty fail safe, it's important to consider what use the space
              has. Ruth Mottershead, Creative Director at Little Greene agrees.
              'For example, the kitchen is often the hub of the family home –
              usually a place of activity, the heart of family life and a place
              for entertaining friends. A kitchen therefore is an ideal place to
              make more adventurous colour choices and certainly the space where
              you can really experiment with vibrant colours.'
            </p>
            <br />
            <p className="body-lg m-0">
              'For more tranquil spaces like the bathroom, consider shades that
              exude serenity so you can create a haven within your home. For a
              scheme that provides you with a calm retreat, use colours with
              warm undertones that really bring comfort to a space.
            </p>
          </div>
        </div>
        {/* Image Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            borderBottom: "1px solid black",
            padding: "0",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "50%",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                transition: "all 0.5s ease",
                overflow: "hidden",
              }}
              onMouseEnter={() => handleImageHover(1)}
              onMouseLeave={() => handleImageHover(null)}
            >
              <img
                src={img1}
                alt="Profile 1"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "all 0.5s ease",
                  transform: hoveredImage === 1 ? "scale(1.05)" : "scale(1)",
                  filter:
                    hoveredImage === 1 ? "brightness(1.05)" : "brightness(1)",
                }}
              />
            </div>
          </div>
          <div
            style={{
              width: "100%",
              height: "50%",
              display: "flex",
              flexDirection: "row",
              gap: "0",
            }}
          >
            <div
              style={{
                width: "50%",
                height: "100%",
                overflow: "hidden",
                position: "relative",
              }}
              onMouseEnter={() => handleImageHover(2)}
              onMouseLeave={() => handleImageHover(null)}
            >
              <img
                src={img2}
                alt="Profile 1"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "all 0.5s ease",
                  transform: hoveredImage === 2 ? "scale(1.05)" : "scale(1)",
                  filter:
                    hoveredImage === 2 ? "brightness(1.05)" : "brightness(1)",
                }}
              />
            </div>
            <div
              style={{
                width: "50%",
                height: "100%",
                overflow: "hidden",
                position: "relative",
              }}
              onMouseEnter={() => handleImageHover(3)}
              onMouseLeave={() => handleImageHover(null)}
            >
              <img
                src={img3}
                alt="Profile 1"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "all 0.5s ease",
                  transform: hoveredImage === 3 ? "scale(1.05)" : "scale(1)",
                  filter:
                    hoveredImage === 3 ? "brightness(1.05)" : "brightness(1)",
                }}
              />
            </div>
          </div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
      {/* Header Row */}
      {!isMobile && (
        <div className="d-flex justify-content-center">
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
          <div
            style={{
              width: "45%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            <div
              style={{
                padding: isMobile ? "20px 40px" : "40px 40px",
              }}
            >
              <h3 className="m-0 heading-sm text-uppercase">
                1. HARMONIOUS COLORS
              </h3>
            </div>
          </div>
          <div
            style={{
              width: "45%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            {" "}
            <div
              style={{
                padding: isMobile ? "20px 40px" : "40px 40px",
              }}
            >
              <h3 className="m-0 heading-sm text-uppercase">2. TONAL COLORS</h3>
            </div>
          </div>
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        </div>
      )}
      {!isMobile && (
        <div className="d-flex justify-content-center">
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              // borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
          <div
            style={{
              width: "45%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            <p
              style={{
                fontFamily: "BodoniModa_18pt",
                fontSize: "24px",
              }}
              className="px-5 py-3"
            >
              Choosing adjacent colors on the wheel – yellow and green, for
              instance – is a straightforward way of creating an
              easy-to-live-with scheme. These harmonious colors are the most
              widely used group in interior design.
            </p>
          </div>
          <div
            style={{
              width: "45%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            <p
              style={{
                fontFamily: "BodoniModa_18pt",
                fontSize: "24px",
              }}
              className="px-5 py-3"
            >
              Tonal colors are basically a variety of shades of one color, also
              known as tone-on-tone or monochromatic (not to be confused with
              monochrome). Decorating with this color palette will result in a
              uniform scheme as it uses only different tones - both lighter and
              darker - of one color.
            </p>
          </div>

          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              // borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        </div>
      )}
      {!isMobile && (
        <div className="d-flex justify-content-center">
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
          <div
            style={{
              width: "45%",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div
              style={{
                height: "100%",
                overflow: "hidden",
              }}
              onMouseEnter={() => handleImageHover(4)}
              onMouseLeave={() => handleImageHover(null)}
            >
              <img
                src={img4}
                alt="Profile 1"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  maxHeight: "400px",
                  transition: "all 0.5s ease",
                  transform: hoveredImage === 4 ? "scale(1.05)" : "scale(1)",
                  filter:
                    hoveredImage === 4 ? "brightness(1.05)" : "brightness(1)",
                }}
              />
            </div>
          </div>
          <div
            style={{
              width: "45%",
              borderBottom: "1px solid black",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div
              style={{
                height: "100%",
                overflow: "hidden",
              }}
              onMouseEnter={() => handleImageHover(5)}
              onMouseLeave={() => handleImageHover(null)}
            >
              <img
                src={img5}
                alt="Profile 1"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  maxHeight: "400px",
                  transition: "all 0.5s ease",
                  transform: hoveredImage === 5 ? "scale(1.05)" : "scale(1)",
                  filter:
                    hoveredImage === 5 ? "brightness(1.05)" : "brightness(1)",
                }}
              />
            </div>
          </div>

          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        </div>
      )}

      {isMobile && (
        <div
          className="d-flex justify-content-center"
          style={{
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          <div className="w-100">
            <h3
              className="heading-sm m-0"
              style={{
                padding: "20px 40px",
                borderBottom: "1px solid black",
              }}
            >
              1. FLAMINGO PINK, AQUAMARINE GREEN
            </h3>
            <p
              className="body-lg m-0"
              style={{
                padding: "20px 40px",
                borderBottom: "1px solid black",
              }}
            >
              This contrasting scheme pits a pale aquamarine against a flamingo
              hued pink. Accessorized with a splash of rich fuschia pink on the
              mirror frame, the pale blue flooring gives it an air of a modern
              classic.
            </p>
            <div
              style={{
                height: "100%",
                overflow: "hidden",
              }}
              onMouseEnter={() => handleImageHover(6)}
              onMouseLeave={() => handleImageHover(null)}
            >
              <img
                src={img4}
                alt="Profile 1"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  maxHeight: "600px",
                  transition: "all 0.5s ease",
                  transform: hoveredImage === 6 ? "scale(1.05)" : "scale(1)",
                  filter:
                    hoveredImage === 6 ? "brightness(1.05)" : "brightness(1)",
                }}
              />
            </div>
            <h3
              className="heading-sm m-0"
              style={{
                padding: "20px 40px",
                borderBottom: "1px solid black",
              }}
            >
              2. BLUE HUES
            </h3>
            <p
              className="body-lg m-0"
              style={{
                padding: "20px 40px",
                borderBottom: "1px solid black",
              }}
            >
              Using variations of one color is a calming approach. Here, the
              deep blue hue of the chest of drawers makes a sophisticated
              backdrop to the lighter tinted powder blues of the upholstery,
              while the teal bowl adds an additional layer of color.
            </p>
            <div
              style={{
                height: "100%",
                overflow: "hidden",
              }}
              onMouseEnter={() => handleImageHover(6)}
              onMouseLeave={() => handleImageHover(null)}
            >
              <img
                src={img5}
                alt="Profile 1"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  maxHeight: "600px",
                  transition: "all 0.5s ease",
                  transform: hoveredImage === 6 ? "scale(1.05)" : "scale(1)",
                  filter:
                    hoveredImage === 6 ? "brightness(1.05)" : "brightness(1)",
                }}
              />
            </div>
          </div>
        </div>
      )}
      {/* Header Row */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: "1px solid black",
            // borderLeft: "1px solid black",
          }}
        >
          <div
            style={{
              padding: "20px 40px",
            }}
          >
            <h3 className="heading-sm m-0">3. CONTRASTING COLORS</h3>
          </div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "45%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: "1px solid black",
            // borderLeft: "1px solid black",
          }}
        >
          <div
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                padding: "20px 40px",
              }}
            >
              <p className="body-lg m-0">
                Also referred to as complimentary colors, these are guaranteed
                to add drama to any room. By taking shades that sit opposite
                each other on the wheel, such as red and blue, you can create a
                rich, vibrant scheme packed with drama and energy. A split
                complementary (or contrasting) scheme is a slight variation,
                using a base color and two adjacent colors opposite it.
              </p>
              <br />
              <p className="body-lg m-0">
                'When creating a contrasting palette, we recommend thinking
                about splitting the room into ratios,' says Helen Shaw, UK
                Director at Benjamin Moore, 'with main colour being 60% of the
                scheme, 30% the secondary and 10% an accent. The accent colour
                can help to break up an ultra-contrasting scheme and allows the
                look to be tied together.'
              </p>
            </div>
          </div>
        </div>
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <div
            style={{
              height: "100%",
              overflow: "hidden",
            }}
            onMouseEnter={() => handleImageHover(6)}
            onMouseLeave={() => handleImageHover(null)}
          >
            <img
              src={img6}
              alt="Profile 1"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                maxHeight: "600px",
                transition: "all 0.5s ease",
                transform: hoveredImage === 6 ? "scale(1.05)" : "scale(1)",
                filter:
                  hoveredImage === 6 ? "brightness(1.05)" : "brightness(1)",
              }}
            />
          </div>
        </div>

        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
